module.exports = __webpack_public_path__ + "img/dobrovolnici.2c18ae6b.svg";